import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './assets/stylus/main.styl'
import VueAnalytics from 'vue-analytics'
import './sass/main.scss'

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueAnalytics, {
    id: 'UA-149261089-1',
    router
  })
}

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

